import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '../base/baseQuery'

export const lessonServiceApi = createApi({
  reducerPath: 'lessonServiceApi',
  baseQuery: baseQuery,
  tagTypes: ['Lesson'],
  endpoints: (builder) => ({
    getLessonsBySubjectId: builder.query({
      query: (subjectId) => `/backoffice/subjects/${subjectId}/lessons`,
      providesTags: (result, error, subjectId) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: 'Lesson', id })),
              { type: 'Lesson', id: 'LIST' },
            ]
          : [{ type: 'Lesson', id: 'LIST' }],
    }),
    addLesson: builder.mutation({
      query: (newLesson) => ({
        url: '/backoffice/lessons/save',
        method: 'POST',
        body: newLesson,
      }),
      invalidatesTags: [{ type: 'Lesson', id: 'LIST' }],
    }),
    updateLesson: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/backoffice/lessons/update/${id}`,
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Lesson', id },
        { type: 'Lesson', id: 'LIST' },
      ],
    }),
    deleteLesson: builder.mutation({
      query: (id) => ({
        url: `/backoffice/lessons/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Lesson', id: 'LIST' }],
    }),
  }),
})

export const {
  useGetLessonsBySubjectIdQuery,
  useAddLessonMutation,
  useUpdateLessonMutation,
  useDeleteLessonMutation,
} = lessonServiceApi
